<template>
    <v-card class="px-4">
        <v-card-title class="headline pl-0">Edit Schedule</v-card-title>
        <v-card-actions class="mx-0 mb-2">
            <v-checkbox
                class="ml-2"
                label="Select All"
                v-model="allSelected"
                color="green"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
                @click="newPaymentMethodDialog = true"
                flat
                small
                class=""
                color="success"
                >New Payment Method</v-btn
            >
            <v-select
                class="ml-1"
                style="max-width: 36%;"
                :items="paymentMethods.map((p) => p.cardInfo)"
                v-model="selectedCard"
                label="Payment Method"
                @input="changePaymentMethod"
            ></v-select>
        </v-card-actions>

        <v-divider></v-divider>

        <v-card-text
            class="pa-0 mt-3"
            v-if="schedule.scheduleDetails"
            style="height: 500px;"
        >
            <div
                class="scroll"
                height="50"
                v-for="(scheduleDetail, index) in schedule.scheduleDetails"
            >
                <v-layout row class="reduce-margin">
                    <v-checkbox
                        class="ml-2"
                        v-model="scheduleDetail.selected"
                        color="green"
                    ></v-checkbox>
                    <v-text-field
                        style="width: 20%;"
                        disabled
                        class="px-1 mr-1"
                        label="Amount"
                        placeholder="Amount"
                        v-model="scheduleDetail.amount"
                        :rules="amountRules"
                        type="number"
                        prefix="$"
                    ></v-text-field>
                    <v-menu
                        class="px-1 mr-2"
                        v-model="scheduleDetail.datePickerMenu"
                        :close-on-content-click="true"
                        offset-y
                        full-width
                        prepend-icon="mdi-currency-usd"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="scheduleDetail.scheduleDate"
                                :value="scheduleDetail.scheduleDate"
                                label="Date"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="scheduleDetail.scheduleDate"
                            :min="today"
                        ></v-date-picker>
                    </v-menu>
                    <v-select
                        style="width: 36%;"
                        :items="paymentMethods.map((m) => m.cardInfo)"
                        label="Payment Method"
                        v-model="scheduleDetail.cardInfo"
                    ></v-select>
                </v-layout>
            </div>
        </v-card-text>
        <v-divider class="mb-3"></v-divider>
        <v-card-actions class="mr-0 my-2">
            <v-checkbox
                v-model="dontAuthorize"
                label="Don't Authorize Card"
                hide-details
                class="mt-0"
                color="success"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn color="default" dark class="mr-1" @click="closeDialog()"
                >Cancel</v-btn
            >
            <v-btn
                color="warning"
                class="mr-1"
                :disabled="schedule.scheduleDetails.every((s) => !s.selected)"
                @click="confirmScheduleCancellation"
                >Cancel Schedules</v-btn
            >
            <v-btn color="success" @click="confirmScheduleChanges">
                Save
            </v-btn>
        </v-card-actions>

        <v-dialog
            persistent
            v-model="confirmScheduleChangeDialog"
            max-width="400"
            ><v-card class="px-2">
                <v-card-title class="text-warning headline "
                    >Are You Sure?</v-card-title
                ><v-card-text class="py-0 font-weight-medium"
                    >Please Confirm the Changes bellow</v-card-text
                >
                <v-list>
                    <template v-for="(detail, index) in getChangedSchedules()">
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    formatDate(detail.scheduleDate)
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title></v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action
                                >${{ detail.amount }}</v-list-tile-action
                            >
                            <v-spacer></v-spacer>
                            <v-list-tile-action>{{
                                detail.cardInfo
                            }}</v-list-tile-action>
                        </v-list-tile>
                        <v-divider
                            v-if="index + 1 < getChangedSchedules().length"
                            :key="index"
                        ></v-divider>
                    </template>
                </v-list>
                <v-card-actions class="mx-0 px-2 pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmScheduleChangeDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveSchedule"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card></v-dialog
        >

        <v-dialog persistent v-model="confirmCancellationDialog" max-width="400"
            ><v-card class="px-2">
                <v-card-title class="text-warning headline "
                    >Are You Sure?</v-card-title
                ><v-card-text class="py-0 font-weight-medium"
                    >This will cancel the follwing Scheduled
                    Payments</v-card-text
                >
                <v-list>
                    <template
                        v-for="(detail,
                        index) in schedule.scheduleDetails.filter(
                            (s) => s.selected
                        )"
                    >
                        <v-list-tile>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    formatDate(detail.scheduleDate)
                                }}</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action
                                >${{ detail.amount }}</v-list-tile-action
                            >
                        </v-list-tile>
                        <v-divider
                            v-if="
                                index + 1 <
                                    schedule.scheduleDetails.filter(
                                        (s) => s.selected
                                    ).length
                            "
                            :key="index"
                        ></v-divider>
                    </template>
                </v-list>
                <v-card-actions class="mx-0 px-2 pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="confirmCancellationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="cancelling"
                        color="success"
                        @click="cancelSelectedSchedlues"
                    >
                        Confirm
                    </v-btn></v-card-actions
                >
            </v-card></v-dialog
        >
        <v-dialog v-model="newPaymentMethodDialog" max-width="400">
            <new-payment-method
                :accountID="accountID"
                :closeDialog="closeNewPaymentMethodDialog"
                :onSave="updateSelectedPaymentMethod"
            ></new-payment-method>
        </v-dialog>
    </v-card>
</template>

<script>
import moment from "moment";
import newPaymentMethod from "../Payment/NewPaymentMethod.vue";

export default {
    props: {
        schedule: Object,
        originalSchedule: Object,
        closeDialog: Function,
        accountID: String,
        updateSelected: Function,
        scheduleDetailColumns: Array,
        paymentMethods: Array,
        reloadPage: Function,
    },
    components: {
        newPaymentMethod,
    },
    data() {
        return {
            menu: false,
            processing: false,
            cancelling: false,
            dontAuthorize: false,
            selectedCard: "",

            confirmScheduleChangeDialog: false,
            confirmCancellationDialog: false,
            newPaymentMethodDialog: false,

            today: new Date().toISOString().substr(0, 10),

            amountRules: [
                (value) => !!value || "Amount Is Required",
                (value) => {
                    return !value || value > 0 || "Amount Can't Be Negative";
                },
            ],
        };
    },
    async created() {},
    watch: {},
    computed: {
        allSelected: {
            get() {
                return this.schedule.scheduleDetails.every((s) => s.selected);
            },
            set(select) {
                this.schedule.scheduleDetails.forEach(
                    (s) => (s.selected = select)
                );
            },
        },
    },
    methods: {
        getCardLastUsed() {
            if (!this.paymentMethods.length) return "";

            return this.paymentMethods
                .sort((a, b) => {
                    if (Date.parse(a.lastUsed) > Date.parse(b.lastUsed))
                        return -1;
                    if (Date.parse(a.lastUsed) < Date.parse(b.lastUsed))
                        return 1;
                    return 0;
                })
                .reverse()[0].cardInfo;
        },
        hasNoChanges() {
            return this.schedule.scheduleDetails.every((detail, index) => {
                const original = this.originalSchedule.scheduleDetails[index];

                return this.isEquivalent(original, detail);
            });
        },
        isEquivalent(original, copy) {
            var originalProps = Object.keys(original).filter(
                (p) => p != "selected"
            );
            var copyProps = Object.keys(copy).filter((p) => p != "selected");

            if (originalProps.length != copyProps.length) {
                return false;
            }

            for (var i = 0; i < originalProps.length; i++) {
                var propName = originalProps[i];

                if (original[propName] !== copy[propName]) {
                    return false;
                }
            }

            return true;
        },
        confirmScheduleChanges() {
            if (this.hasNoChanges()) {
                this.$notify({
                    text: "No change has been made.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.confirmScheduleChangeDialog = true;
        },
        getChangedSchedules() {
            return this.schedule.scheduleDetails.filter((detail, index) => {
                const original = this.originalSchedule.scheduleDetails[index];

                return !this.isEquivalent(original, detail);
            });
        },
        async saveSchedule() {
            this.processing = true;

            const schedules = this.getChangedSchedules().map((schedule) => ({
                scheduleID: schedule.scheduleId,
                scheduleDetailID: schedule.scheduleDetailId,
                amount: schedule.amount,
                date: schedule.scheduleDate,
                paymentMethodID: schedule.paymentMethodID,
                user: this.$store.state.authentication.user,
                dontAuthorize: this.dontAuthorize,
            }));

            try {
                await this.$http.post(
                    "api/payments/updateSchedules",
                    schedules
                );

                this.closeDialog();
                this.confirmScheduleChangeDialog = false;

                this.processing = false;

                this.$notify({
                    text: "Schedule Saved",
                    group: "notification",
                    type: "success",
                });

                this.reloadPage();
            } catch (e) {
                this.processing = false;

                return;
            }
        },
        confirmScheduleCancellation() {
            this.confirmCancellationDialog = true;
        },
        async cancelSelectedSchedlues() {
            const scheduleIDs = this.schedule.scheduleDetails
                .filter((payment) => payment.selected)
                .map((s) => s.scheduleDetailId);

            await this.cancel(scheduleIDs);
        },
        async cancel(scheduleIDs) {
            this.cancelling = true;

            try {
                await this.$http.post("api/payments/cancelScheduledPayments", {
                    accountID: this.accountID,
                    scheduleIDs: scheduleIDs,
                    user: this.$store.state.authentication.user,
                });

                this.closeDialog();
                this.confirmCancellationDialog = false;

                this.cancelling = false;

                this.$notify({
                    text: "Cancellation Successful",
                    group: "notification",
                    type: "success",
                });

                this.reloadPage();
            } catch (e) {
                this.cancelling = false;

                return;
            }
        },
        formatDate(date) {
            return moment(date).format("L");
        },
        changePaymentMethod(value) {
            if (!this.schedule.scheduleDetails.some((s) => s.selected)) {
                this.$notify({
                    text:
                        "Nothing was changed. Please select the schedules you want to change.",
                    group: "notification",
                    type: "warning",
                });
            }

            const paymentMethodID = this.paymentMethods.find(
                (pm) => pm.cardInfo == value
            ).id;

            this.schedule.scheduleDetails
                .filter((s) => s.selected)
                .forEach((detail) => {
                    detail.paymentMethodID = paymentMethodID;
                    detail.cardInfo = value;
                });
        },
        closeNewPaymentMethodDialog() {
            this.newPaymentMethodDialog = false;
        },
        updateSelectedPaymentMethod(paymentMethod) {
            paymentMethod.cardInfo =
                paymentMethod.cardType + " - " + paymentMethod.cardNumberLast5;

            this.paymentMethods.push(paymentMethod);

            this.selectedCard = paymentMethod.cardInfo;

            this.changePaymentMethod(paymentMethod.cardInfo);
        },
    },
};
</script>
<style>
.reduce-margin .v-input__slot {
    margin-bottom: 0;
}

.scroll {
    overflow-y: auto;
}
</style>
